@if (reconnecting$ | async) {
  <div class="chat-connection-banner chat-connection-banner-reconnecting font-xs"
       [translate]="'common.chat.reconnecting'">
    Reconnecting...
  </div>
}

@if (connectionLost$ | async) {
  <div class="chat-connection-banner chat-connection-banner-offline font-xs"
       [translate]="'common.chat.offline'">
    Connection lost. Reload the page to see new messages.
  </div>
}

<ui-chat [messages]="messages$ | async"
         [imageUploader]="imageUploader"
         [placeholder]="placeholder"
         [sending]="sending$ | async"
         [draftResetKey]="draftResetKey$ | async"
         (onMessageSend)="sendMessage($event)">
  <ng-content select="[ui_chat_pinned_message]"></ng-content>
  <ng-content select="[ui_chat_footer]"></ng-content>
</ui-chat>

@let sendError = sendError$ | async;
@if (sendError) {
  <div class="chat-send-error font-xs">
    {{ sendError }}
  </div>
}


@if (loadError$ | async) {
  <div class="chat-load-error">
    <div class="font-md" [translate]="'common.unexpectedErrorReloadPage'">
      Unexpected error, please refresh the page
    </div>
    <div class="text-end">
      <button class="btn btn-pink px-5 mt-3"
              (click)="reloadPage()"
              [translate]="'common.chat.reloadPage'">
        Reload page
      </button>
    </div>
  </div>
}

